export default "__VITE_ASSET__CGZi9OxD__"